import { Card, Checkbox, Input } from 'antd';
import styled from 'styled-components';

export const Text = styled.p`
  color: ${({ theme }) => theme.colors.black10};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 20px 0;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-top: 20px;
`;

export const LabelSpan = styled.span`
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SearchInput = styled(Input)`
  margin-bottom: 16px;
`;

export const SectionCard = styled(Card)<{ $selected: boolean }>`
  cursor: pointer;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.colors.green1 : theme.colors.white};
  border: 1px solid
    ${({ $selected, theme }) => ($selected ? theme.colors.green6 : theme.colors.black4)};
  border-radius: 8px;
  margin-bottom: 12px;

  .ant-card-body {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
  }

  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover {
    border-color: ${({ $selected, theme }) =>
      $selected ? theme.colors.green6 : theme.colors.black4};
    background-color: ${({ theme }) => theme.colors.green1};
  }
`;

export const GreenCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;

export const SectionsList = styled.div`
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;
`;
